exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".caption-fa3d6111{text-align:center;font-style:italic;color:#666}\n", ""]);

// Exports
exports.locals = {
	"caption": "caption-fa3d6111"
};